import { supabase } from '../supabase/supabaseClient.js';

// Servicio especializado en métricas de planes
export const calculatePlanMetrics = async (companyId) => {
  try {
    // Obtener todos los planes de la compañía
    const { data: productos } = await supabase
      .from('producto')
      .select('id')
      .eq('compania_id', companyId);

    const productIds = productos?.map(p => p.id) || [];
    
    if (productIds.length === 0) {
      return {
        planes_con_sesiones: [],
        planes_con_simulaciones: [],
        planes_con_contrataciones: [],
        total_planes_con_actividad: 0,
        resumen_actividad: {
          total_planes: 0,
          planes_con_sesiones_count: 0,
          planes_con_simulaciones_count: 0,
          planes_con_contrataciones_count: 0,
          porcentaje_planes_activos: 0
        }
      };
    }

    const { data: planes } = await supabase
      .from('planes')
      .select('id, nombre, activo, producto_id')
      .in('producto_id', productIds);

    const planIds = planes?.map(p => p.id) || [];

    if (planIds.length === 0) {
      return {
        planes_con_sesiones: [],
        planes_con_simulaciones: [],
        planes_con_contrataciones: [],
        total_planes_con_actividad: 0,
        resumen_actividad: {
          total_planes: 0,
          planes_con_sesiones_count: 0,
          planes_con_simulaciones_count: 0,
          planes_con_contrataciones_count: 0,
          porcentaje_planes_activos: 0
        }
      };
    }

    // Obtener cotizaciones relacionadas a los planes
    const { data: cotizaciones } = await supabase
      .from('cotizaciones')
      .select('id, plan_id, sesion_id, created_at')
      .in('plan_id', planIds);

    // Obtener contrataciones relacionadas a las cotizaciones
    const cotizacionIds = cotizaciones?.map(c => c.id) || [];
    const { data: contrataciones } = await supabase
      .from('contrataciones')
      .select('id, cotizacion_id, created_at')
      .in('cotizacion_id', cotizacionIds);

    // Obtener sesiones relacionadas a las cotizaciones
    const sesionIds = cotizaciones?.filter(c => c.sesion_id).map(c => c.sesion_id) || [];
    const { data: sesiones } = await supabase
      .from('sesiones')
      .select('id, datos_simulacion, created_at')
      .in('id', sesionIds);

    // Procesar métricas por plan
    const planesConSesiones = [];
    const planesConSimulaciones = [];
    const planesConContrataciones = [];

    planes?.forEach(plan => {
      const cotizacionesPlan = cotizaciones?.filter(c => c.plan_id === plan.id) || [];
      const sesionIdsPlan = cotizacionesPlan.filter(c => c.sesion_id).map(c => c.sesion_id);
      const sesionesPlan = sesiones?.filter(s => sesionIdsPlan.includes(s.id)) || [];
      const simulacionesPlan = sesionesPlan.filter(s => s.datos_simulacion);
      
      const cotizacionIdsPlan = cotizacionesPlan.map(c => c.id);
      const contratacionesPlan = contrataciones?.filter(c => cotizacionIdsPlan.includes(c.cotizacion_id)) || [];

      // Plan con sesiones
      if (sesionesPlan.length > 0) {
        planesConSesiones.push({
          plan_id: plan.id,
          plan_nombre: plan.nombre,
          total_sesiones: sesionesPlan.length,
          total_cotizaciones: cotizacionesPlan.length,
          activo: plan.activo
        });
      }

      // Plan con simulaciones
      if (simulacionesPlan.length > 0) {
        planesConSimulaciones.push({
          plan_id: plan.id,
          plan_nombre: plan.nombre,
          total_simulaciones: simulacionesPlan.length,
          total_cotizaciones: cotizacionesPlan.length,
          activo: plan.activo
        });
      }

      // Plan con contrataciones
      if (contratacionesPlan.length > 0) {
        planesConContrataciones.push({
          plan_id: plan.id,
          plan_nombre: plan.nombre,
          total_contrataciones: contratacionesPlan.length,
          total_cotizaciones: cotizacionesPlan.length,
          activo: plan.activo
        });
      }
    });

    // Contar planes únicos con algún tipo de actividad
    const planesConActividad = new Set([
      ...planesConSesiones.map(p => p.plan_id),
      ...planesConSimulaciones.map(p => p.plan_id),
      ...planesConContrataciones.map(p => p.plan_id)
    ]);

    return {
      planes_con_sesiones: planesConSesiones,
      planes_con_simulaciones: planesConSimulaciones,
      planes_con_contrataciones: planesConContrataciones,
      total_planes_con_actividad: planesConActividad.size,
      resumen_actividad: {
        total_planes: planes?.length || 0,
        planes_con_sesiones_count: planesConSesiones.length,
        planes_con_simulaciones_count: planesConSimulaciones.length,
        planes_con_contrataciones_count: planesConContrataciones.length,
        porcentaje_planes_activos: planes?.length > 0 ? 
          ((planesConActividad.size / planes.length) * 100).toFixed(2) : 0
      }
    };
  } catch (error) {
    console.error('Error calculating plan metrics:', error);
    return {
      planes_con_sesiones: [],
      planes_con_simulaciones: [],
      planes_con_contrataciones: [],
      total_planes_con_actividad: 0,
      resumen_actividad: {
        total_planes: 0,
        planes_con_sesiones_count: 0,
        planes_con_simulaciones_count: 0,
        planes_con_contrataciones_count: 0,
        porcentaje_planes_activos: 0
      }
    };
  }
};

export default {
  calculatePlanMetrics
};